import React, { useState } from "react";
import axios from "axios";
import { Box, TextField, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import DashboardLayout from "../../../../components/global/DashboardLayout";
import ActionButton from "../../../../components/shared/ActionButton";

const Dictionary = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [word, setWord] = useState("");
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);

  const handleSearchWord = async () => {
    try {
      const response = await axios.get(
        `https://api.dictionaryapi.dev/api/v2/entries/en/${word}`
      );
      setResults(response.data);
      setError(null);
    } catch (err) {
      setError("Word not found");
      setResults(null);
    }
  };

  return (
    <DashboardLayout>
      <Box mb="30px">
        <Typography
          variant="h2"
          color={colors.grey[100]}
          fontWeight="bold"
          textTransform="uppercase"
          sx={{ mb: "5px" }}
        >
          Dictionary
        </Typography>
        <Typography variant="h5" color={colors.greenAccent[400]}>
          Search every word from dictionary what you want
        </Typography>
      </Box>

      <Box display="flex" mb="20px">
        <TextField
          fullWidth
          variant="filled"
          type="text"
          label="Search every word from dictionary"
          value={word}
          autoComplete="off"
          onChange={(e) => setWord(e.target.value)}
          sx={{ height: "60px" }}
        />
        <ActionButton
          colors={colors}
          title="Search"
          onClick={handleSearchWord}
          sx={{ ml: 1, mt: 0.5 }}
        />
      </Box>

      {error && <Typography color={colors.redAccent[500]}>{error}</Typography>}

      {results && (
        <Box
          mt="20px"
          p={3}
          sx={{ background: colors.blueAccent[700], borderRadius: "5px" }}
        >
          {results.map((entry, index) => (
            <Box key={index}>
              <Typography variant="h4" color="#fff">
                {entry.word}
              </Typography>
              {entry.meanings.map((meaning, mIndex) => (
                <Box key={mIndex}>
                  <Typography variant="h6" color={colors.greenAccent[400]}>
                    {meaning.partOfSpeech}
                  </Typography>
                  {meaning.definitions.map((definition, dIndex) => (
                    <Typography key={dIndex} variant="body1" color="#fff">
                      {definition.definition}
                    </Typography>
                  ))}
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      )}
    </DashboardLayout>
  );
};

export default Dictionary;
